import { render, staticRenderFns } from "./daily-events.vue?vue&type=template&id=5ed0eec2&"
import script from "./daily-events.vue?vue&type=script&lang=js&"
export * from "./daily-events.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports